import { DebounceSettings } from 'lodash';

export const socketDebounceTime = 200;
export const socketDebouncConfig: DebounceSettings = {
  leading: false,
  trailing: true,
  maxWait: 1000,
};
